import {
  Statistics_Get as overview,
  request as rawRequest,
  getDomain,
} from './backend'

const getAvailableStatistics = async () => {
  let {data} = await overview()
  return data
}

const queryById = async (queryID, req) => {
  const domain = getDomain()
  let path = '/api/management/statistics/' + queryID.toLowerCase()
  let queryParameters = {}
  let form = {}
  const config = {}
  if (req) {
    Object.keys(req).forEach(function(parameterName) {
      queryParameters[parameterName] = req[parameterName]
    })
  }

  let {data} = await rawRequest(
    'get',
    domain + path,
    {},
    queryParameters,
    form,
    config,
  )
  return data
}

export default {
  getAvailableStatistics,
  queryById,
}
